import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import {
  updateMeasurement,
  addMeasurement
} from './actions'
import Measurement from './measurement';
import { measurementTypes } from '../../../../Globals/constants'
import { semanticColors, greyScaleColors } from '../../../../Globals/styles';

class Measurements extends Component{
  constructor(props) {
    super(props);
    this.state = {
      selectpickerChildren: this.getTypeSelectPickerChildren()
    }
  }
  addMeasurement = (index) => {
    if(index===this.props.measurements.length-1){
      this.props.dispatch(addMeasurement());
    }
  };
  getTypeSelectPickerChildren = () => {
    let selectpickerChildren = [];
    measurementTypes.forEach((measurementType, index) => {
      if(index === 0){
        selectpickerChildren.push(
          <option
            key={index}
            value={0}>
            Intet valgt
          </option>
        )
      }
      selectpickerChildren.push(
        <option
          key={index+1}
          value={measurementType}>
          {measurementType}
        </option>
      )
    })
    return selectpickerChildren
  };
  isContainerActive = () => {
    const { measurements } = this.props;
    for (let i = 0; i < measurements.length; i++) {
      if(measurements[i].type && measurements[i].type!=="0")
        return true
    }
    return false
  };
  render()  {
    const { measurements, dispatch } = this.props;
    let measurementNodes = measurements.map((measurement, index) => {
      return (
        <Measurement
          key={index}
          measurement={measurement}
          selectpickerChildren={this.state.selectpickerChildren}
          updateMeasurement={(typeOf, value) => {
            dispatch(updateMeasurement(typeOf, index, value))
            this.addMeasurement(index)
          }}
        />
      )
    })

    return (
      <div style={styles.outerContainer}>
        <div className="row" style={[styles.container, this.isContainerActive() && styles.containerActive, false && styles.containerError]}>
          <div style={styles.heading}>
            Opmåling
          </div>
          <div className="row" style={styles.headingContainer}>
            <div style={[styles.colHeading, styles.firstColumn]}>Type</div>
            <div style={[styles.colHeading, styles.secondColumn]}>Antal (stk/snit)</div>
            <div style={[styles.colHeading, styles.thirdColumn]}>Længde (cm) <br /> Diameter (mm)</div>
            <div style={[styles.colHeading, styles.forthColumn]}>Dybde(cm)</div>
            <div style={[styles.colHeading, styles.fifthColumn]}>Område/sted</div>
          </div>
          {measurementNodes}
        </div>
      </div>
    );
  }
}

var styles = {
  outerContainer: {
    margin: '0 0 12px 0',
    paddingRight: '12px'
  },
  container: {
    backgroundColor: greyScaleColors.greyLighter,
    padding: '2px 0 8px 6px',
    margin: '0',
    borderLeft: '2px solid ' + semanticColors.mainBackground
  },
  containerActive: {
    borderLeft: '2px solid ' + semanticColors.info
  },
  containerError: {
    borderLeft: '2px solid ' + semanticColors.danger
  },
  heading: {
    marginBottom: '5px'
  },
  colHeading:{
    fontSize: '12px',
    textAlign: 'left'
  },
  headingContainer: {
    margin: '0'
  },
  firstColumn: {
    width: '21%',
    padding: '17px 12px 4px 0',
    float: 'left'
  },
  secondColumn: {
    width: '12%',
    padding: '0 12px 4px 12px',
    float: 'left',
    textAlign: 'right'
  },
  thirdColumn: {
    width: '20%',
    padding: '0 12px 4px 12px',
    float: 'left',
    textAlign: 'right'
  },
  forthColumn: {
    width: '12%',
    padding: '17px 12px 4px 12px',
    float: 'left',
    textAlign: 'right'
  },
  fifthColumn: {
    width: '35%',
    padding: '17px 12px 4px 12px',
    float: 'left'
  }
}


const selectProps = state => {
  return {
    ...state.dailyReportMeasurementsReducer
  };
}
  Measurements.propTypes = {
    dispatch: PropTypes.func.isRequired,
    measurements: PropTypes.arrayOf(PropTypes.shape({
      type: PropTypes.string.isRequired,
      length: PropTypes.number.isRequired,
      depth: PropTypes.number.isRequired,
      area: PropTypes.string,
      amount: PropTypes.number.isRequired
    }))
  };
export default connect(selectProps)(Radium(Measurements));


// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Measurements/index.jsx